var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridWord({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.885,
    height: 37.855,
    viewBox: "0 0 29.885 37.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75031",
    "data-name": "Group 75031",
    transform: "translate(-304 -669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62926",
    "data-name": "Path 62926",
    d: "M312.344,414.893v23.227a1.992,1.992,0,0,1-1.992,1.992h-25.9a1.993,1.993,0,0,1-1.992-1.992v-33.87a1.992,1.992,0,0,1,1.992-1.992H299.71a4.049,4.049,0,0,1,2.863,1.185l8.586,8.586A4.05,4.05,0,0,1,312.344,414.893Z",
    transform: "translate(21.541 266.743)",
    fill: "#ebf5fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63718",
    "data-name": "Path 63718",
    d: "M-7.182,6H-4.3l2.659-9.153h.109L1.138,6H4.022L8.028-8H4.795L2.478,1.748H2.354L-.2-8H-2.964L-5.521,1.728h-.116L-7.954-8h-3.233Z",
    transform: "translate(320.188 690)",
    fill: "#2874a6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridWord);
export default __webpack_public_path__ + "static/media/grid_word.71dd4ae4552fbe54a62c012163524d2e.svg";
export { ForwardRef as ReactComponent };